export const setUserData = (user_data) => {
  return { type: "set_user_data", payload: user_data };
};

export const setActiveRoleId = (role_id) => {
  return { type: "set_active_role_id", payload: role_id };
};
